import React from "react";
import { Briefcase, GraduationCap, Wrench, Mail, Phone, MapPin } from "lucide-react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function IconRowTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl p-8 shadow-2xl text-[13px] leading-relaxed" data-testid="resume-live-preview">
      <h1 className="text-2xl font-bold">{draft.full_name || "Your Name"}</h1>
      {draft.target_role && <p className="text-sm font-semibold mt-0.5" style={{ color: accent }}>{draft.target_role}</p>}
      <div className="flex flex-wrap gap-3 text-slate-500 text-[11px] mt-2">
        {draft.contact_email && <span className="flex items-center gap-1"><Mail className="w-3 h-3" />{draft.contact_email}</span>}
        {draft.contact_phone && <span className="flex items-center gap-1"><Phone className="w-3 h-3" />{draft.contact_phone}</span>}
        {draft.location && <span className="flex items-center gap-1"><MapPin className="w-3 h-3" />{draft.location}</span>}
      </div>
      <div className="w-full h-px bg-slate-200 my-4" />

      {draft.summary && <p className="text-slate-700 mb-4">{draft.summary}</p>}

      {draft.experience.length > 0 && (
        <div className="mb-4">
          <h2 className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}><Briefcase className="w-3.5 h-3.5" /> Experience</h2>
          {draft.experience.map((e, i) => (
            <div key={i} className="mb-2.5">
              <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
              <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
            </div>
          ))}
        </div>
      )}
      {draft.education.length > 0 && (
        <div className="mb-4">
          <h2 className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}><GraduationCap className="w-3.5 h-3.5" /> Education</h2>
          {draft.education.map((ed, i) => <p key={i} className="text-slate-700">{ed.degree} {ed.field} — {ed.school}</p>)}
        </div>
      )}
      {draft.skills.length > 0 && (
        <div className="mb-4">
          <h2 className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}><Wrench className="w-3.5 h-3.5" /> Skills</h2>
          <p className="text-slate-700">{draft.skills.join(", ")}</p>
        </div>
      )}
      <ExtraResumeSections draft={draft} accent={accent} />
    </div>
  );
}
